var _excluded = ["size"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';

var Bitcoin24 = function Bitcoin24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M21.7 14.42c-1.336 5.356-6.761 8.616-12.12 7.281C4.224 20.365.963 14.94 2.3 9.582 3.634 4.224 9.062.963 14.418 2.3c5.358 1.337 8.619 6.762 7.283 12.12z",
    fill: "#F5922F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.346 10.57c.19-1.332-.78-2.047-2.105-2.524l.43-1.802-1.05-.273-.418 1.754c-.28-.072-.56-.14-.84-.207l.42-1.766-1.048-.274-.43 1.802a33.868 33.868 0 0 1-.67-.164l.001-.006-1.447-.377-.28 1.171s.779.187.761.198c.426.112.503.405.49.638l-.49 2.054a.78.78 0 0 1 .11.037l-.111-.029-.686 2.876c-.053.135-.184.337-.481.26.01.016-.764-.199-.764-.199l-.52 1.257 1.366.356c.253.066.503.136.747.201l-.434 1.823 1.049.274.43-1.804c.286.082.564.156.836.227l-.428 1.796 1.05.273.434-1.82c1.79.354 3.136.212 3.702-1.48.457-1.363-.023-2.15-.964-2.662.685-.165 1.201-.637 1.34-1.61zm-2.398 3.514c-.324 1.363-2.52.627-3.23.442l.575-2.415c.712.185 2.994.552 2.655 1.974v-.001zm.323-3.534c-.295 1.239-2.122.61-2.714.455l.523-2.19c.592.154 2.5.441 2.192 1.735z",
    fill: "#fff"
  }));
};

Bitcoin24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var sizeMap = {
  '24': Bitcoin24
};
export var Bitcoin = function Bitcoin(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      props = _objectWithoutProperties(_ref, _excluded);

  var Icon = sizeMap[size] || sizeMap['24'];

  if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test' && !sizeMap[size]) {
    throw new Error("The '".concat(size, "' size is not supported by the 'Bitcoin' icon. Please use one of the available sizes: '24'."));
  }

  return /*#__PURE__*/React.createElement(Icon, props);
};